 import React, { Component } from 'react';
import { injectSheet } from 'redux-form-jsonschema-reactstrap'
import { InputField } from 'redux-form-jsonschema-reactstrap'

function radios2(_options) {
  const { styles, ...options } = _options;
  class CreatedInputField extends Component {
    render() {
      var items = []
      for ( var i = 0; i <=2; i = i+1) {
        items.push(<InputField type="radio" {...this.props} {...options} />)
      }
      return (
        <div>
        <h1>HUGO</h1>
        {items}
        </div>
      )
    }
  }
  return injectSheet(styles)(CreatedInputField);
}


export default radios2({})
